module.exports = __webpack_public_path__ + "img/hair_front_male_short_mask.522cfb7c.png";